/**
 *
 * @param url 外部链接地址
 * @description 打开外部链接
 * @returns void
 */
export function openExternalLink(url: string) {
    if (typeof url !== "string" || !/^https?:\/\//.test(url)) return
    const anchor = document.createElement("a")
    anchor.href = url
    anchor.target = "_blank"
    anchor.rel = "noopener noreferrer"
    anchor.click()
}
